import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../molecules/button/button.component';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-show-more-less',
  standalone: true,
  imports: [CommonModule, ButtonComponent, CapitalizePipe],
  templateUrl: './show-more-less.component.html',
  styleUrls: ['./show-more-less.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ShowMoreLessComponent implements AfterViewInit, OnChanges {
  @ViewChild('itemList', { static: true }) itemList: ElementRef =
    {} as ElementRef;

  @Input() initialVisibleItems: number = 4;
  @Input() step: number = 4;
  @Input() buttonMoreLabel: string = 'Mehr anzeigen';
  @Input() buttonLessLabel: string = 'Weniger anzeigen';

  items: HTMLElement[] = [];
  visibleItemsCount: number = this.initialVisibleItems;
  ButtonType = ButtonType;

  constructor() {}

  ngAfterViewInit(): void {
    // Delay the initialization to ensure the DOM is fully rendered
    setTimeout(() => {
      this.initializeItems();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialVisibleItems'] || changes['step']) {
      this.visibleItemsCount = this.initialVisibleItems;
      this.initializeItems(); // Reinitialize items when inputs change
    }
  }

  private initializeItems(): void {
    this.items = Array.from(this.itemList.nativeElement.children);
    this.updateVisibility();
  }

  toggleVisibility(): void {
    this.visibleItemsCount =
      this.visibleItemsCount < this.items.length
        ? Math.min(this.visibleItemsCount + this.step, this.items.length)
        : this.initialVisibleItems;
    this.updateVisibility();
  }

  private updateVisibility(): void {
    this.items = Array.from(this.itemList.nativeElement.children);

    this.items.forEach((item, index) => {
      const isVisible = index < this.visibleItemsCount;

      if (isVisible) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }

  get toggleLabel(): string {
    return this.visibleItemsCount < this.items.length
      ? this.buttonMoreLabel
      : this.buttonLessLabel;
  }

  get toggleIcon(): string {
    return this.visibleItemsCount < this.items.length ? 'plus' : 'minus';
  }
}
